import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { waLink, trackEvent } from "@/lib/whatsapp";

export default function WhatsAppButton() {
  const { settings } = useSettings();
  const wa = settings?.whatsapp;
  if (!wa?.enabled) return null;
  return (
    <a
      href={waLink(wa.number, wa.default_message)}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      onClick={() => trackEvent("whatsapp_click", { location: "float" })}
      className="fixed bottom-24 right-4 lg:bottom-5 lg:right-5 z-40 flex items-center gap-2 rounded-full bg-green-500 hover:bg-green-600 text-white pl-4 pr-5 py-3 shadow-lg shadow-green-500/30 transition-transform hover:scale-105 active:scale-95"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="hidden sm:inline font-medium text-sm">Chat with us</span>
    </a>
  );
}
